<template>
  <v-expansion-panel>
    <v-expansion-panel-content>
      <template v-slot:actions>
        <nt-icon color="primary">
          list
        </nt-icon>
      </template>
      <template v-slot:header>
        <div>Displaying {{ headers.filter(h => h.checked).length }} of {{ headers.length }} Columns</div>
      </template>
      <v-card>
        <v-card-text>
          <v-card>
            <v-layout wrap>
              <v-flex v-for="(header, index) in headers" :key="index" xs6 sm2>
                <v-checkbox :key="header.text" v-model="header.checked" :label="header.text" class="ma-0" />
              </v-flex>
            </v-layout>
          </v-card>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  export default {
    props: ['headers']
  }
</script>
